import { readGoalSnapshot } from './registry';
import { canEditGoal, canPublishGoal } from './validation';

export const resolveCampaignGoal = (campaign = {}) => {
  const snapshot = readGoalSnapshot({
    pluginKey: campaign.goalPluginKey || campaign.goal_plugin_key || campaign.pluginKey || campaign.goalType || campaign.goal_type || 'subscription',
    pluginVersion: campaign.goalPluginVersion || campaign.goal_plugin_version || campaign.pluginVersion || '1.0.0',
    configSchemaVersion: campaign.goalConfigSchemaVersion || campaign.goal_config_schema_version || campaign.configSchemaVersion || null,
    config: campaign.goalConfig || campaign.goal_config || campaign.config || {},
  });
  return { ...snapshot, editable: canEditGoal(snapshot), publishable: canPublishGoal(snapshot) };
};
